import * as React from "react";
const SvgSearch = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.0473 14.0453L11.1445 11.1426", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeWidth: 1.30423, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.35851 12.7082C10.3136 12.7082 12.7092 10.3126 12.7092 7.35753C12.7092 4.40242 10.3136 2.00684 7.35851 2.00684C4.4034 2.00684 2.00781 4.40242 2.00781 7.35753C2.00781 10.3126 4.4034 12.7082 7.35851 12.7082Z", stroke: "#A3A3A3", style: {
  stroke: "#A3A3A3",
  stroke: "color(display-p3 0.6375 0.6375 0.6375)",
  strokeOpacity: 1
}, strokeWidth: 1.30423, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgSearch;
